import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { List, ListSubHeader, ListCheckbox } from 'react-toolbox/lib/list'
import { compose } from 'recompose'

import ListDivider from './Divider'

import styles from './styles.scss'

const DialogList = ({ onClick, caption, list }) => {
  // alert(JSON.stringify(list))
  return (
    <List
      selectable
      theme={styles}
    >
      <ListSubHeader
        caption={caption}
        theme={styles}
      />
      { list.reduce((acc, { checked, index, type, value }, n) => {
        const checkbox = (
          <ListCheckbox
            key={value}
            caption={type}
            checked={checked}
            onChange={(check) => onClick(check, value)}
            theme={styles}
          />
        )
        acc.push(checkbox)
        acc.push(<ListDivider key={`${caption}_list_divider_${n}`}/>)
        return acc
      }, [])}
    </List>
  )
}

DialogList.propTypes = {
  caption: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired
}

DialogList.defaultProps = {
  caption: '',
  list: [],
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(DialogList)
